import { TabView, TabPanel } from "primereact/tabview";
import "primeicons/primeicons.css";
import Nouvelles from "./globale/nouvelles";
import Repondeur from "./globale/repondeur";
import Encours from "./globale/encours";
import Traites from "./globale/traites";
import Abandonnes from "./globale/abandonnes";
import Toutes from "./globale/toutes";

export default function ZotSuivisToutes() {

  return (
    <>
      <TabView>
        <TabPanel header="Nouvelles">
          <Nouvelles />
        </TabPanel>

        <TabPanel header="Répondeur">
          <Repondeur />
        </TabPanel>

        <TabPanel header="En cours">
          <Encours />
        </TabPanel>

        <TabPanel header="Traités">
          <Traites />
        </TabPanel>

        <TabPanel header="Abandonnés">
          <Abandonnes />
        </TabPanel>

        <TabPanel header="Toutes">
          <Toutes />
        </TabPanel>
      </TabView>
    </>
  );
}
